document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.menu-item--has-children').forEach(item => {
    const submenu = item.querySelector('ul');
    if (!submenu) return;

    const toggle = document.createElement('button');
    toggle.classList.add('menu-toggle');
    toggle.setAttribute('aria-label', 'Toggle submenu');
    toggle.textContent = '+';
    item.firstElementChild.insertAdjacentElement('afterend', toggle);

    toggle.addEventListener('click', e => {
      e.preventDefault();
      item.classList.toggle('menu-item--open');
      toggle.textContent = item.classList.contains('menu-item--open') ? '–' : '+';
    });
  });
});